import { KeycloakService } from 'keycloak-angular';
import { environment } from '../../environments/environment';

export function initializeKeycloak(keycloak: KeycloakService) {
  console.log(
    '🚀 Client ID usato per Keycloak:',
    environment.keycloak.clientId,
  );
  console.log('🌍 Keycloak URL:', environment.keycloak.url);
  console.log('🌍 Redirect URI:', window.location.origin + '/auth/callback');
  return () => {
    return keycloak.init({
      config: {
        url: environment.keycloak.url,
        realm: 'intre',
        clientId: environment.keycloak.clientId,
      },
      initOptions: {
        onLoad: 'login-required',
        redirectUri: window.location.origin + '/',
        checkLoginIframe: false,
        enableLogging: true,
      },
      enableBearerInterceptor: true,
    });
  };
}
